import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://yehzsmvmeaxteqjdqixe.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InllaHpzbXZtZWF4dGVxamRxaXhlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgzMzc1NjcsImV4cCI6MjA5MzkxMzU2N30.b5fEvnH61ePaXF6Xf2H477-7P5vDWLzXYeF6pKW52HE';

export const supabase = createClient(supabaseUrl, supabaseKey);